export default {"src":"/_next/static/media/mondial-logotype-white-rgb.49695a69.svg","height":450,"width":450,"blurWidth":0,"blurHeight":0};